import { render, staticRenderFns } from "./STGradientBackground.vue?vue&type=template&id=0223c54e"
var script = {}
import style0 from "./STGradientBackground.vue?vue&type=style&index=0&id=0223c54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports